import { api } from "@/lib/api";
import { stopAddress } from "@/components/routes/RouteMap";

const rad = (d) => (d * Math.PI) / 180;
const miles = (a, b) => {
  const h = Math.sin(rad(b.lat - a.lat) / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(rad(b.lon - a.lon) / 2) ** 2;
  return 3959 * 2 * Math.asin(Math.sqrt(h));
};

// Keeps the chosen first stop, then always drives to the closest stop not yet visited.
export async function orderByClosest(stops, start = 0) {
  const coords = {};
  for (const a of [...new Set(stops.map(stopAddress))]) {
    coords[a] = await api.get("/route-setup/geocode", { params: { address: a } }).then((r) => r.data).catch(() => ({}));
  }
  const at = (s) => (coords[stopAddress(s)]?.lat != null ? coords[stopAddress(s)] : null);
  const first = stops[start];
  let rest = stops.filter((_, i) => i !== start);
  const unplaced = rest.filter((s) => !at(s));
  rest = rest.filter((s) => at(s));
  const out = [first];
  let here = at(first);
  while (rest.length) {
    let k = 0;
    if (here) rest.forEach((s, j) => { if (miles(here, at(s)) < miles(here, at(rest[k]))) k = j; });
    const [next] = rest.splice(k, 1);
    out.push(next);
    here = at(next);
  }
  return { stops: [...out, ...unplaced], unplaced: unplaced.length };
}
